import { Box, IconButton, Modal, SxProps, Theme, Typography } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { NJIM } from "../../../../theme/njimTheme";
import { useTranslation } from "react-i18next";

interface CustomModalProps {
  open: boolean;
  onClose: () => void;
  ModalTitle?: string;
  ModalDescription?: string;
  width?: string | number | Record<string, string | number>;
  children?: React.ReactNode;
  bgcolor?: string;
  paperSx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
  descriptionSx?: SxProps<Theme>;
  hideHeader?: boolean;
}

const CustomModal: React.FC<CustomModalProps> = ({
  open,
  onClose,
  ModalTitle,
  ModalDescription,
  width = "50%",
  children,
  bgcolor,
  paperSx,
  titleSx,
  descriptionSx,
  hideHeader = false,
}) => {
  const { t } = useTranslation();
  return (
    <Modal open={open} onClose={onClose}>
      <>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width,
            bgcolor: bgcolor || NJIM.white,
            borderRadius: "16px",
            border: `1px solid ${NJIM.border}`,
            boxShadow: NJIM.elevationLg,
            p: { xs: 2.5, sm: 4 },
            maxHeight: { xs: "92vh", sm: "80vh" },
            overflow: "auto",
            ...paperSx,
          }}
        >
          {!hideHeader ? (
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: 700,
                  color: NJIM.ink,
                  ...titleSx,
                }}
              >
                {ModalTitle}
              </Typography>
              <IconButton
                onClick={onClose}
                aria-label={t("common.close")}
                sx={{
                  background: NJIM.muted,
                  borderRadius: "10px",
                  "&:hover": { background: NJIM.inkSoft },
                }}
              >
                <CloseIcon sx={{ fontSize: 20, color: NJIM.textSecondary }} />
              </IconButton>
            </Box>
          ) : null}
          {!hideHeader && ModalDescription && (
            <Typography
              sx={{
                fontSize: "13px",
                color: NJIM.textSecondary,
                mt: 0.3,
                ...descriptionSx,
              }}
            >
              {ModalDescription}
            </Typography>
          )}
          <Box>{children}</Box>
        </Box>
      </>
    </Modal>
  );
};

export default CustomModal;
